"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _topicHelpfulness = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-helpfulness/topicHelpfulness"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _axios = _interopRequireDefault(require("axios"));

var _config = require("@insided/deprecated-libs/config");

var _Analytics = _interopRequireDefault(require("@insided/deprecated-preact-components/analytics/Analytics"));

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-helpfulness';
exports.cssAnchorName = cssAnchorName;

var getTopicTypeV2 = function getTopicTypeV2(hasBestAnswer, contentType) {
  if (contentType === 'question') {
    return hasBestAnswer ? _config.topicTypes.ANSWERED : _config.topicTypes.QUESTION;
  } else if (contentType === 'article') {
    return _config.topicTypes.ARTICLE;
  }

  return _config.topicTypes.DISCUSSION;
};

var getOldScrollV2 = function getOldScrollV2() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.scrollY || document.documentElement.scrollTop;
};

var getScrollBoundariesV2 = function getScrollBoundariesV2() {
  var _firstPostElement$get;

  var firstPostElement = document.querySelector('.qa-topic-first-post');
  var firstPost = (_firstPostElement$get = firstPostElement === null || firstPostElement === void 0 ? void 0 : firstPostElement.getBoundingClientRect()) !== null && _firstPostElement$get !== void 0 ? _firstPostElement$get : null;
  var hasReplyBox = document.querySelector('.qa-reply') !== null;
  var replyBoxElement = document.querySelector('.qa-reply');
  var replyBox = hasReplyBox && replyBoxElement ? replyBoxElement.getBoundingClientRect() : null;

  if (!firstPost || !replyBox) {
    return null;
  }

  return {
    firstPost: firstPost.height + firstPost.top,
    replyBoxTop: replyBox.top > window.innerHeight,
    replyBoxBottom: replyBox.top < window.innerHeight,
    hasReplyBox: hasReplyBox
  };
};

var ContentHelpfulness = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentHelpfulness, _Component);

  var _super = _createSuper(ContentHelpfulness);

  function ContentHelpfulness(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentHelpfulness);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "oldScroll", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStorage", function () {
      if (typeof window === 'undefined') return;
      var data = JSON.parse(window.localStorage.getItem('topicHelpfulness') || '{}');
      data[_this.props.contentHelpfulness.id] = {
        value: _this.state.value,
        isDismissed: _this.state.isDismissed,
        isRemoved: _this.state.isRemoved
      };
      window.localStorage.setItem('topicHelpfulness', JSON.stringify(data));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeWidget", function () {
      _this.setState({
        isRemoved: true
      }, function () {
        return _this.updateStorage();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideWidget", function () {
      window.removeEventListener('scroll', _this.onScroll);

      _this.setState({
        animationClass: 'easy-out'
      });

      window.setTimeout(function () {
        _this.setState({
          isDismissed: true,
          isSticky: false,
          animationClass: ''
        });
      }, 300);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setData", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  animationClass: 'fade-out'
                });

                window.setTimeout(function () {
                  _this.setState({
                    value: value,
                    animationClass: ''
                  });

                  window.setTimeout(function () {
                    _this.hideWidget();
                  }, 3000);
                }, 300);

                _Analytics.default.send('Topic helpfulness', _config.ratingDataMap.ga[value]);

                _publish.default.trackEvent('userevent', {
                  type: 'Topic Rated',
                  rating: _config.ratingDataMap.messagebus[value],
                  topic_title: _this.props.contentHelpfulness.title,
                  topic_type: getTopicTypeV2(_this.props.contentHelpfulness.hasBestAnswer, _this.props.contentHelpfulness.contentType),
                  topic_id: _this.props.contentHelpfulness.id,
                  topic_url: window.location.origin + window.location.pathname,
                  topic_views: _this.props.contentHelpfulness.views,
                  source: 'community'
                });

                _context.next = 6;
                return _axios.default.post(_config.CONTENT_HELPFULNESS_VOTE_URL, {
                  topic: _this.props.contentHelpfulness.id,
                  vote: value
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScroll", function () {
      var isSticky = _this.state.isSticky;
      var boundaries = getScrollBoundariesV2();
      var newScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (newScroll < _this.oldScroll) {
        _this.oldScroll = newScroll;
      } else {
        _this.setState({
          isSticky: false
        });

        _this.oldScroll = newScroll;
        return;
      }

      if (!boundaries) {
        return;
      }

      if (!isSticky && boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
        _this.setState({
          isSticky: true
        });
      } else if (isSticky && (boundaries.firstPost > 0 || boundaries.hasReplyBox && boundaries.replyBoxBottom)) {
        _this.setState({
          isSticky: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getConfiguration", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$axios$get, data;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.state.configurationLoaded) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return _axios.default.get(_config.CONTENT_HELPFULNESS_SETTINGS_URL, {
                params: {
                  topicId: _this.props.contentHelpfulness.id,
                  topicType: getTopicTypeV2(_this.props.contentHelpfulness.hasBestAnswer, _this.props.contentHelpfulness.contentType)
                }
              });

            case 4:
              _yield$axios$get = _context2.sent;
              data = _yield$axios$get.data;

              _this.setState({
                visible: data.visible,
                indicatorEnabled: data.indicatorEnabled,
                helpfulnessPercentage: data.helpfulnessPercentage,
                configurationLoaded: true
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.state = {
      value: null,
      isDismissed: false,
      isRemoved: false,
      isSticky: false,
      animationClass: null,
      visible: false,
      indicatorEnabled: false,
      helpfulnessPercentage: null,
      configurationLoaded: false
    };
    _this.oldScroll = getOldScrollV2();
    return _this;
  }

  (0, _createClass2.default)(ContentHelpfulness, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') return;
      var data = JSON.parse(window.localStorage.getItem('topicHelpfulness') || '{}');

      if (data[this.props.contentHelpfulness.id]) {
        var _data$this$props$cont = data[this.props.contentHelpfulness.id],
            value = _data$this$props$cont.value,
            isDismissed = _data$this$props$cont.isDismissed,
            isRemoved = _data$this$props$cont.isRemoved;

        if (!isRemoved) {
          this.getConfiguration();
        }

        this.setState({
          value: value,
          isDismissed: isDismissed,
          isRemoved: isRemoved
        });
      } else {
        this.getConfiguration();
      }

      window.addEventListener('beforeunload', function () {
        if (_this2.state.value) {
          _this2.removeWidget();
        }
      });

      if (!this.state.isDismissed) {
        var boundaries = getScrollBoundariesV2();

        if (!boundaries) {
          return;
        }

        if (boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
          this.setState({
            isSticky: true
          });
        }

        window.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateStorage();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          phrases = _this$props.phrases,
          renderWithClasses = _this$props.renderWithClasses;
      var _this$state = this.state,
          animationClass = _this$state.animationClass,
          isRemoved = _this$state.isRemoved,
          value = _this$state.value,
          isDismissed = _this$state.isDismissed,
          isSticky = _this$state.isSticky,
          visible = _this$state.visible,
          indicatorEnabled = _this$state.indicatorEnabled,
          helpfulnessPercentage = _this$state.helpfulnessPercentage;
      var isVoted = value;

      if (isRemoved || isDismissed && isSticky || !visible) {
        return null;
      }

      var topicHelpfulness = (0, _preact.h)(_topicHelpfulness.default, {
        setData: this.setData,
        hideWidget: this.hideWidget,
        isVoted: isVoted,
        isSticky: isSticky,
        phrases: phrases.Forum,
        showIndicator: indicatorEnabled,
        indicatorPercentage: helpfulnessPercentage,
        animationClass: animationClass
      });
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          'qa-topic-helpfulness topic-helpfulness_component-wrapper': renderWithClasses,
          'content-helpfulness-sidebar': _common.common.isModuleActive('threadedRepliesDestination')
        })
      }, topicHelpfulness, Boolean(isSticky) && (0, _preact.h)(_preactPortal.default, {
        into: "#comments"
      }, topicHelpfulness));
    }
  }]);
  return ContentHelpfulness;
}(_preact.Component);

var _default = ContentHelpfulness;
exports.default = _default;